<template>
   <div>   
      <CContainer fluid class="pricing-f capa">
      <div class="text-right">
      <CButton @click="logout"> <CIcon name="cilAccountLogout" /> Sair </CButton>
      </div>
                  <div class="col-md-12">
                  <CContainer class="d-inline-block">
                     <span class="text-white"><h1>Status PPA <h5>Última atualização às {{this.ultima}}</h5></h1> </span>
                  </CContainer>
                  </div>               
                  <div class="row mt-2" style="background: #04182d;">               
                     <div class="col-md-12 col-sm-12" >                  
                        <div class="feature">                    
                     <iframe class="pricing-f-b" width="1041" height="616" src="https://app.powerbi.com/view?r=eyJrIjoiY2NiYTM0YzItZWEwZC00MmMxLTk3OTktMjU4YjIwMzMzOWY5IiwidCI6IjIyNjgzZDNiLWUwN2QtNDNhYi1hNDM5LTg5ZWQzNGMzMjg5NyJ9&pageName=ReportSection" frameborder="0" allowFullScreen="true"></iframe>                
                     </div>
                     </div>		 
                  </div>    

                  <div class="row" style="background: #04182d;">               
                     <div class="col-md-12 col-sm-12" >                  
                        <div class="feature">                    
                     <iframe class="pricing-f-b" width="1041" height="616" src="https://app.powerbi.com/view?r=eyJrIjoiNDQzYTEyNjQtMWUxYy00ODE5LTlhOWQtMzA4NmFlMmJiODY0IiwidCI6IjIyNjgzZDNiLWUwN2QtNDNhYi1hNDM5LTg5ZWQzNGMzMjg5NyJ9&pageName=ReportSection22f14262cc1daca4fdfc" frameborder="0" allowFullScreen="true"></iframe>                
                     </div>
                     </div>		 
                  </div>   

                  <div class="row" style="background: #04182d;">               
                     <div class="col-md-12 col-sm-12" >                  
                        <div class="feature">                    
                     <iframe class="pricing-f-b" width="1041" height="616" src="https://app.powerbi.com/view?r=eyJrIjoiOTBjNzcxMTYtZDYyMy00NDRjLThhZWItOWQzYjFmMTc5MjAwIiwidCI6IjIyNjgzZDNiLWUwN2QtNDNhYi1hNDM5LTg5ZWQzNGMzMjg5NyJ9&pageName=ReportSectione3b72d2c4a952d251f7d" frameborder="0" allowFullScreen="true"></iframe>                
                     </div>
                     </div>		 
                  </div>   

                  <div class="row" style="background: #04182d;">               
                     <div class="col-md-12 col-sm-12" >                  
                        <div class="feature">                    
                     <iframe class="pricing-f-b" width="1041" height="616" src="https://app.powerbi.com/view?r=eyJrIjoiNmQ5NWQyOWMtYmYyOC00ZWMzLThlZTAtN2FhNmFkMGIxNzhlIiwidCI6IjIyNjgzZDNiLWUwN2QtNDNhYi1hNDM5LTg5ZWQzNGMzMjg5NyJ9&pageName=ReportSection01a984210b7979c53182" frameborder="0" allowFullScreen="true"></iframe>                
                     </div>
                     </div>		 
                  </div>   

                  <div class="row" style="background: #04182d;">               
                     <div class="col-md-12 col-sm-12" >                  
                        <div class="feature">                    
                     <iframe class="pricing-f-b" width="1041" height="556" src="https://app.powerbi.com/view?r=eyJrIjoiNTlkNTBhNmUtY2NmOC00M2U2LTk1OTEtN2E5ZTU5YmE1YzVmIiwidCI6IjIyNjgzZDNiLWUwN2QtNDNhYi1hNDM5LTg5ZWQzNGMzMjg5NyJ9" frameborder="0" allowFullScreen="true"></iframe>                
                     </div>
                     </div>		 
                  </div> 
                  
   </CContainer>   
   </div>    
</template>

<script>
import firebase from 'firebase';

export default {
   name: 'Status',    
   data () {
    return {         
         ultima: "15:11 de 16/07/2021"                                          
         }          
      },   
   methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.go({ path: this.$router.path });
        });
    }
  }   
           
     
}
</script>

<style scoped>


@import url('https://fonts.googleapis.com/css?family=Raleway:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i');

/**-- font-family: 'Raleway', sans-serif; --**/


/*------------------------------------------------------------- 
	2. BASE CSS 
-------------------------------------------------------------*/
.sair {
   padding-left: auto;
}

.btn {
   color: white; 
   padding-top: 2px;   
   
   
}

/* .capa {  
   border: 3px solid #fff;
} */


.inline {
   display: inline;   
}
/*-- Pricing --*/

.section-pricing {
	background: #07203e;
	background: -moz-linear-gradient(top, #07203e 0, #07223f 8%, #092344 14%, #072442 16%, #0a2445 16%, #082545 23%, #092648 23%, #092847 28%, #0a264b 33%, #0a2749 34%, #0b294b 34%, #0b294b 100%);
	background: -webkit-linear-gradient(top, #07203e 0, #07223f 8%, #092344 14%, #072442 16%, #0a2445 16%, #082545 23%, #092648 23%, #092847 28%, #0a264b 33%, #0a2749 34%, #0b294b 34%, #0b294b 100%);
	background: linear-gradient(to bottom, #07203e 0, #07223f 8%, #092344 14%, #072442 16%, #0a2445 16%, #082545 23%, #092648 23%, #092847 28%, #0a264b 33%, #0a2749 34%, #0b294b 34%, #0b294b 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#07203e', endColorstr='#0b294b', GradientType=0);
	padding-top: 15px;
	padding-bottom: 25px;
}

.pricing-f {
   background-color: rgb(4, 24, 45);
}

.pricing-f-b {   
   margin-left: auto;
   margin-right: auto;
   display: block;   
}

.pricing-f h2 {
	font-size: 26px;
	font-weight: 400;
	padding-top: 30px;
	margin-bottom: 25px;
	color: #fff;
}

.feature {
	margin-bottom: 80px;
}

.feature_icon {
	height: 75px;
}

.feature h3 {
	font-size: 20px;
	font-weight: 300;
	line-height: 1;
	margin-bottom: 22px;
	color: #fff;
}

.feature p {
	color: #90a7c2 !important;
	font-size: 14px;
	font-weight: 300;
	line-height: 27px;
}

.getselectedprimary {
    margin-top: 15px;
    font-size: 16px !important;
    font-weight: 500 !important;
    background-color: #f0ad4e;
    border-radius: 3px;
    line-height: 45px;
    padding: 0 15px;
    color: #fff;
    text-align: center;
	position: relative;
    z-index: 1;
    display: block;
    height: 100%;
    white-space: nowrap;
}
@media (max-width: 552px) {
    .pricing-f h2 {
     font-size: 16px;    
     }
}



</style>